import React from 'react';
import EditableBranchTemplate from '../components/EditableBranchTemplate';
import { communityData } from '../data/communityData';

const Community = () => {
  const handleSave = (updatedContent) => {
    console.log('Saving updated content:', updatedContent);
    alert('Content saved successfully! (Check console for details)');
  };

  return (
    <EditableBranchTemplate
      title="Web3 Community"
      sections={communityData}
      onSave={handleSave}
    />
  );
};

export default Community;
